import React, { useState } from 'react';
import emailjs from 'emailjs-com';

const ComingSoonPage = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Send email using EmailJS
    emailjs.send('service_o39arbh', 'template_3v3rb8o', formData, '5YBmQVHgM84wgJ4vw')
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        alert('Your message has been sent successfully!');
      }, (error) => {
        console.log('FAILED...', error);
        alert('Failed to send your message. Please try again later.');
      });
  };

  React.useEffect(() => {
    // Calculate the target date (two months from now)
    const targetDate = new Date();
    targetDate.setMonth(targetDate.getMonth() + 2);
    targetDate.setHours(0, 0, 0, 0);

    const calculateTimeLeft = () => {
      const difference = targetDate - new Date();
      
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      }
    };

    // Set initial countdown
    calculateTimeLeft();

    // Update countdown every second
    const timer = setInterval(calculateTimeLeft, 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(timer);
  }, []);

  return (
    <div>
      {/* Navigation */}
      <nav className="bg-white shadow-lg">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <a href="/" className="text-2xl font-bold text-blue-600">PredictFlow</a>
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-gray-700 hover:text-blue-600">Return to Home</a>
            </div>
          </div>
        </div>
      </nav>

      <div className="min-h-screen bg-gradient-to-r from-blue-600 to-indigo-600 flex flex-col justify-center items-center text-white">
        <div className="text-center px-4">
          <h1 className="text-5xl font-bold mb-6">Coming Soon</h1>
          <p className="text-xl mb-12">We're working hard to bring something amazing to you!</p>
          
          <div className="grid grid-cols-4 gap-6 max-w-2xl mx-auto mb-12">
            <div className="bg-white bg-opacity-20 p-6 rounded-lg text-center">
              <span className="text-4xl font-bold block">{timeLeft.days}</span>
              <span className="text-sm">Days</span>
            </div>
            <div className="bg-white bg-opacity-20 p-6 rounded-lg text-center">
              <span className="text-4xl font-bold block">{timeLeft.hours}</span>
              <span className="text-sm">Hours</span>
            </div>
            <div className="bg-white bg-opacity-20 p-6 rounded-lg text-center">
              <span className="text-4xl font-bold block">{timeLeft.minutes}</span>
              <span className="text-sm">Minutes</span>
            </div>
            <div className="bg-white bg-opacity-20 p-6 rounded-lg text-center">
              <span className="text-4xl font-bold block">{timeLeft.seconds}</span>
              <span className="text-sm">Seconds</span>
            </div>
          </div>

          <div className="max-w-2xl mx-auto">
            <form onSubmit={handleSubmit} className="bg-white bg-opacity-20 p-8 rounded-lg">
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="firstName" className="block text-sm mb-2">First Name</label>
                  <input 
                    type="text" 
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    required
                    className="w-full px-3 py-2 rounded-lg text-gray-800"
                    placeholder="Enter your first name"
                  />
                </div>
                <div>
                  <label htmlFor="lastName" className="block text-sm mb-2">Last Name</label>
                  <input 
                    type="text" 
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    required
                    className="w-full px-3 py-2 rounded-lg text-gray-800"
                    placeholder="Enter your last name"
                  />
                </div>
              </div>
              <div className="mb-6">
                <label htmlFor="email" className="block text-sm mb-2">Email Address</label>
                <input 
                  type="email" 
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-3 py-2 rounded-lg text-gray-800"
                  placeholder="Enter your email address"
                />
              </div>
              <div className="mb-6">
                <label htmlFor="phone" className="block text-sm mb-2">Phone Number</label>
                <input 
                  type="tel" 
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 rounded-lg text-gray-800"
                  placeholder="Enter your phone number (optional)"
                />
              </div>
              <button 
                type="submit" 
                className="w-full bg-blue-500 hover:bg-blue-600 text-white py-3 rounded-lg"
              >
                Notify Me
              </button>
            </form>
          </div>

          <div className="mt-12 text-sm opacity-75">
            <p>© 2024 Byte Bridge Services. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;